export const ENDPOINTS = {
  COUNTRIES: "/o/headless-admin-address/v1.0/countries",
  EXIT_URL: "/o/chat/exitChat",
  LIST_TYPE_DEFINITION: "/o/headless-admin-list-type/v1.0/list-type-definitions",
  POLL_URL: "/o/chat/getPoll",
  POST_QUERY_DATA: "/o/chat/userChatQuery",
  QUEUE_URL: "/o/chat/getQueueState",
  SEND_MESSAGE_URL: "/o/chat/sendMessages",
  SEND_SURVEY: "/o/chat/customerChatSurvey",
  START_URL: "/o/chat/startChat",
  TYPE_OF_CATEGORY: "/o/chat/categoryQueryData?category=",
  TYPE_STATE_URL: "/o/chat/setTypeState",
  LIST_TYPES: "/o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code"
};
